import { createApiActions } from '@tabeeb/shared/utils/actions'

export const runWorkflow = createApiActions('RUN_WORKFLOW')
export const getWorkflows = createApiActions('GET_WORKFLOWS')
export const getTenantWorkflows = createApiActions('GET_TENANT_WORKFLOWS')
export const addTenantWorkflow = createApiActions('ADD_TENANT_WORKFLOW')
export const removeTenantWorkflow = createApiActions('REMOVE_TENANT_WORKFLOW')
